import { useCallback, useMemo } from 'react';
import { useGetCommunityBlockedUserIdsQuery } from 'generated/graphql';
import { CommunityId } from '../model/community.types';
import { AuthorId } from '../model/post.types';

// Permission-style hook: returns a settled predicate rather than Async<T>. A
// not-yet-loaded blocklist reads as "not blocked" by design, so the Blocked tag
// never flashes before the query resolves. Data hooks (feed, replies) keep
// using Async<T>; gate/permission hooks intentionally collapse loading to false.
export const useIsAuthorBlocked = (communityId: CommunityId) => {
  const { data } = useGetCommunityBlockedUserIdsQuery({
    variables: { communityId },
    fetchPolicy: 'cache-and-network',
  });

  const blockedIds = useMemo(
    () => new Set((data?.blockedUsers ?? []).map((user) => user.id)),
    [data],
  );

  return useCallback(
    (authorId: AuthorId) => blockedIds.has(authorId),
    [blockedIds],
  );
};
